import styled from 'styled-components';

import { NewStyleColor } from '../../../../utils/styles-constants';
import { hexToRgba } from '../../../../utils/style';

interface ButtonProps {
	isActive: boolean;
	disabled: boolean;
}

const Label = styled('ul')`
	display: flex;
	margin: 0 0 15px 30px;
	padding: 0;
	padding-right: 15px;
	list-style-type: none;
`;

const LabelItem = styled('li')`
	flex: 1 0 25%;
	background-color: ${hexToRgba(NewStyleColor.White, 10)};

	&:first-child {
		border-radius: 8px 0 0 8px;
	}

	&:last-child {
		border-radius: 0 8px 8px 0;
	}

	&:only-child {
		border-radius: 8px;
	}
`;

const Button = styled('button')`
	width: 100%;
	height: 30px;
	padding: 0 5px;
	background-color: transparent;
	font-family: HelveticaNeue, sans-serif;
	font-weight: 600;
	font-size: 13px;
	line-height: 30px;
	letter-spacing: 0.15px;
	text-align: center;
	color: ${({ isActive }: ButtonProps) => isActive ? NewStyleColor.White : hexToRgba(NewStyleColor.White, 50)};
	white-space: nowrap;
	border-radius: 8px;
	border: 0;
	outline: 0;
	cursor: ${({ disabled }: ButtonProps) => disabled ? 'default' : 'pointer'};

	${({ isActive }: ButtonProps) => isActive && `
		background-color: ${hexToRgba(NewStyleColor.White, 20)};
	`}
`;

export {
	Label,
	LabelItem,
	Button,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/Label/styles.ts